import React, { useContext } from "react";
import AuthContext from "./AuthContext";
import { Navigate } from "react-router-dom";

// Access Denied Component
const AccessDenied = ({ moduleName }) => {
  return (
    <div className="col-span-10 p-6 bg-white rounded-lg shadow-lg mx-4 my-6">
      <div className="text-center">
        <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
          <svg
            className="h-6 w-6 text-red-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 19.5c-.77.833.192 2.5 1.732 2.5z"
            />
          </svg>
        </div>
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          Access Denied
        </h3>
        <p className="text-sm text-gray-500 mb-4">
          You don't have permission to access the <strong>{moduleName}</strong>{" "}
          module.
        </p>
        <p className="text-xs text-gray-400">
          Please contact your administrator to request access to this module.
        </p>
      </div>
    </div>
  );
};

// Permission Wrapper Component
function PermissionWrapper({ children, requiredModule }) {
  const auth = useContext(AuthContext);

  // If user is not authenticated, redirect to login
  if (!auth.user) {
    return <Navigate to="/login" replace />;
  }

  // Get user data from localStorage
  const userData = JSON.parse(localStorage.getItem("user") || "{}");

  // Check if user has permissions for the required module
  const hasReadPermission = (userPermissions, moduleName) => {
    if (!userPermissions || !Array.isArray(userPermissions)) {
      return false;
    }

    // Find the module in user permissions
    const modulePermission = userPermissions.find(
      (perm) => perm.module === moduleName
    );

    // Check if the module exists and has read permission
    if (modulePermission && modulePermission.permissions) {
      return modulePermission.permissions.includes("read");
    }

    return false;
  };

  // Check permission for the required module
  if (
    requiredModule &&
    !hasReadPermission(userData.permissions, requiredModule)
  ) {
    return <AccessDenied moduleName={requiredModule} />;
  }

  // If user has permission or no specific module is required, render children
  return children;
}

export default PermissionWrapper;
